import { isTrue } from '../utils';

export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS'

export const updatePermissions = () => (dispatch, getState) => {
	const general = getState().settings.general;
	const user = getState().user;
	
	if(general.data.umas_status === 0 || user.member_no === 0){
		return dispatch({
			type: UPDATE_PERMISSIONS,
			error: null,
			response: {
				user_can_enrol: false,
				user_can_buy_membership: false,
				cart_available: false
			}
		})
	}
	
	const member = getState().member;
	const userCanEnrol = isTrue(general.data.enrolling_on && (general.data.general_enrol_on || (general.data.early_enrol_on && member.data.early_enrol > 0)) && !isTrue(member.data.no_enrol_member_type))
	const cartAvailable = userCanEnrol || isTrue(general.data.buy_membership_on)

	return dispatch({
		type: UPDATE_PERMISSIONS,
		error: null,
		response: {
			user_can_enrol: userCanEnrol,
			user_can_buy_membership: isTrue(general.data.buy_membership_on),
			cart_available: cartAvailable
		}
	})
}